// GET_GIFT_TRANSACTION
export const GET_GIFT_TRANSACTION = "GET_GIFT_TRANSACTION";

// GET_TRANSACTION_STATS
export const GET_TRANSACTION_STATS = "GET_TRANSACTION_STATS";
